import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Typography } from '@material-ui/core'
import {
  Disc as DiscIcon,
  CheckCircle as CheckCircleIcon,
  XCircle as XCircleIcon,
  ThumbsUp as ThumbsUpIcon,
} from 'react-feather'

import { CookiesByConsentType } from './components'
import { StatsCard } from 'components'

import constants from 'constants/index'
import theme from 'theme'

const DashboardCookie = ({ cookieStats }) => {
  const { cookies: cookieIds } = constants.myLgpd.GRAPH_IDS

  const totalBannersCount = cookieStats?.length

  const totals = cookieStats?.reduce(
    (acc, banner) => {
      acc.full += banner.fullCount || 0
      acc.denied += banner.deniedCount || 0
      acc.partial += banner.partialCount || 0
      return acc
    },
    { full: 0, denied: 0, partial: 0 },
  )

  const {
    full: totalFullConsentCount,
    denied: totalDeniedConsentCount,
    partial: totalPartialConsentCount,
  } = totals

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h4" color="primary">
          Cookies
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item xs={6} md={3}>
            <StatsCard
              icon={<DiscIcon size={24} />}
              label="Banners com Consentimento"
              value={totalBannersCount}
              backgroundColor={theme.palette.primary.main}
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <StatsCard
              icon={<CheckCircleIcon size={24} />}
              label="Consentimentos Aceitos"
              value={totalFullConsentCount}
              backgroundColor={theme.palette.statuses.approved}
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <StatsCard
              icon={<XCircleIcon size={24} />}
              label="Consentimentos Recusados"
              value={totalDeniedConsentCount}
              backgroundColor={theme.palette.statuses.disapproved}
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <StatsCard
              icon={<ThumbsUpIcon size={24} />}
              label="Consentimentos Parciais"
              value={totalPartialConsentCount}
              backgroundColor={theme.palette.statuses.pending}
            />
          </Grid>
          <Grid item xs={12}>
            <CookiesByConsentType
              banners={cookieStats}
              id={cookieIds.cookiesByConsentType}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

DashboardCookie.propTypes = {
  cookieStats: PropTypes.array.isRequired,
}

export default DashboardCookie
